import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

import { ModalDialogComponent } from "./components/modal-dialog/modal-dialog.component";
import { NotificationPaneComponent } from "./components/notification-pane/notification-pane.component";
import { SpinnerComponent } from "./components/spinner/spinner.component";
import { PaginationComponent } from "./form-controls/pagination/pagination.component";

@NgModule({
    imports: [
        HttpClientModule,
        CommonModule,
        PortalModule,
        OverlayModule
    ],
    declarations: [
        ModalDialogComponent,
        PaginationComponent,
        SpinnerComponent,
        NotificationPaneComponent
    ],
    exports: [
        ReactiveFormsModule,
        CommonModule,
        ModalDialogComponent,
        PaginationComponent,
        SpinnerComponent,
        NotificationPaneComponent
    ]
})
export class SharedLibraryModule {
}
